module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"EditCampaign":"Edit campaign","EditProject":"Edit project","validate":"Validate"},"fr":{"EditCampaign":"Modifier la campagne","EditProject":"Modifier le projet","validate":"Valider"},"de":{"EditCampaign":"Kampagne bearbeiten","EditProject":"Ändern Sie das Projekt","validate":"Bestätigen"}}')
  delete Component.options._Ctor
}
